import { Eye, EyeOff } from 'lucide-react'
import { useMaskStore } from '@/stores/mask-store'
import { Button } from './Button'
import { Tooltip } from './Tooltip'

export function MaskToggle() {
  const { isMasked, toggleMask } = useMaskStore()

  const label = isMasked ? 'Show sensitive data' : 'Hide sensitive data'

  return (
    <Tooltip content={label} position="bottom">
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleMask}
        aria-label={label}
        aria-pressed={!isMasked}
      >
        {isMasked ? (
          <Eye className="h-4 w-4" />
        ) : (
          <EyeOff className="h-4 w-4" />
        )}
        <span className="hidden sm:inline">
          {isMasked ? 'Show' : 'Hide'}
        </span>
      </Button>
    </Tooltip>
  )
}
